/* =============================================================
   countries.js — Nationality list + EU membership set
   -------------------------------------------------------------
   NATIONALITIES  — full alphabetical list used in dropdowns
   EU_COUNTRIES   — Set of EU member states (27) used to
                    auto-compute eu_status from nationality
   ============================================================= */

export const NATIONALITIES = [
  'Afghan',
  'Albanian',
  'Algerian',
  'Andorran',
  'Angolan',
  'Argentine',
  'Armenian',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahraini',
  'Bangladeshi',
  'Belarusian',
  'Belgian',
  'Bolivian',
  'Bosnian',
  'Brazilian',
  'Bulgarian',
  'Cambodian',
  'Canadian',
  'Chilean',
  'Chinese',
  'Colombian',
  'Croatian',
  'Cuban',
  'Cypriot',
  'Czech',
  'Danish',
  'Ecuadorian',
  'Egyptian',
  'Estonian',
  'Ethiopian',
  'Finnish',
  'French',
  'Georgian',
  'German',
  'Ghanaian',
  'Greek',
  'Guatemalan',
  'Honduran',
  'Hungarian',
  'Icelandic',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Irish',
  'Israeli',
  'Italian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakh',
  'Kenyan',
  'Kosovar',
  'Kuwaiti',
  'Kyrgyz',
  'Latvian',
  'Lebanese',
  'Libyan',
  'Liechtensteiner',
  'Lithuanian',
  'Luxembourgish',
  'Malaysian',
  'Maltese',
  'Mexican',
  'Moldovan',
  'Monégasque',
  'Mongolian',
  'Montenegrin',
  'Moroccan',
  'Dutch',
  'New Zealander',
  'Nigerian',
  'North Macedonian',
  'Norwegian',
  'Pakistani',
  'Palestinian',
  'Panamanian',
  'Paraguayan',
  'Peruvian',
  'Filipino',
  'Polish',
  'Portuguese',
  'Qatari',
  'Romanian',
  'Russian',
  'Saudi Arabian',
  'Senegalese',
  'Serbian',
  'Singaporean',
  'Slovak',
  'Slovenian',
  'South African',
  'South Korean',
  'Spanish',
  'Sri Lankan',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Tajik',
  'Thai',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Ukrainian',
  'Emirati',
  'British',
  'American',
  'Uruguayan',
  'Uzbek',
  'Venezuelan',
  'Vietnamese',
  'Yemeni',
];

/* ─── EU member states (27) ──────────────────────────────────
   Maps nationality adjective → EU membership.
   Used to auto-compute eu_status when a nationality is selected.
   ============================================================= */
export const EU_NATIONALITIES = new Set([
  'Austrian',
  'Belgian',
  'Bulgarian',
  'Croatian',
  'Cypriot',
  'Czech',
  'Danish',
  'Estonian',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hungarian',
  'Irish',
  'Italian',
  'Latvian',
  'Lithuanian',
  'Luxembourgish',
  'Maltese',
  'Dutch',
  'Polish',
  'Portuguese',
  'Romanian',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Swedish',
]);

/**
 * Returns 'eu' if the nationality is an EU member state, 'extra_eu' otherwise.
 * @param {string} nationality
 * @returns {'eu' | 'extra_eu'}
 */
export function getEuStatus(nationality) {
  return EU_NATIONALITIES.has(nationality) ? 'eu' : 'extra_eu';
}
